import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import {
  ConsumerEmailCampaignRequest,
  ConsumerEmailCampaignResult
} from "../models/consumer-email-campaign.model";

/**
 * PURPOSE: responsible for triggering the consumer referral email campaign. Business-line/Category
 * lookup is intentionally not duplicated here — the component reuses ConsumerSmsCampaignService's
 * getBusinessLines(), since that data is channel-agnostic.
 */
@Injectable({
  providedIn: "root"
})
export class ConsumerEmailCampaignService {
  constructor(private http: HttpClient) {}

  runCampaign(request: ConsumerEmailCampaignRequest): Observable<ConsumerEmailCampaignResult> {
    return this.http
      .post<ConsumerEmailCampaignResult>(
        `${environment.fulcrumUrl}/api/v3/consumer-email-campaign/referral-anniversary`,
        request,
        this.buildBasicHttpOptions()
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error running consumer email campaign:", error);
          return throwError(() => error);
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      })
    };
  }
}
